import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { debounceTime } from 'rxjs';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { IGetCarga } from 'src/app/services/CargaService/carga.model';
import { CargaService } from 'src/app/services/CargaService/carga.service';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import {
  IGetPreco,
  IGetPrecoResponse,
  IPatchPreco
} from 'src/app/services/PrecoService/preco.model';
import { PrecoService } from 'src/app/services/PrecoService/preco.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { ReportService } from 'src/app/services/ReportService/report.service';
import { IGetServico } from 'src/app/services/ServicoService/servico.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { IGetTipoCarreta } from 'src/app/services/TipoCarretaService/tipoCarreta.model';
import { TipoCarretaService } from 'src/app/services/TipoCarretaService/tipoCarreta.service';
import Swal from 'sweetalert2';

import { ITabelaPrecificacao } from './listagem-precificacao-model';
import { formateMoney } from 'src/app/core/utils/utilities';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = {
  name: string;
  value: string | number;
};

@Component({
  selector: 'app-listagem-precificacao',
  templateUrl: './listagem-precificacao.component.html',
  styleUrls: ['./listagem-precificacao.component.scss']
})
export class ListagemPrecificacaoComponent implements OnInit {
  isLoading: boolean = false;
  numeroPagina: number = 0;
  form = this._inicializarFormulario();
  tableData: ITabelaPrecificacao[] | Array<any> = [];
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;

  servicoOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCarretaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  tipoCargaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  visualizarSuspensosOptions: IOptions[] = [
    {
      name: 'Todos',
      value: 0
    },
    {
      name: 'Apenas ativo',
      value: 1
    }
  ];

  tableColumns = [
    { header: 'Serviço', key: 'servico', type: 'text' },
    { header: 'Tipo da Carreta', key: 'tipoCarreta', type: 'text' },
    { header: 'Tipo da Carga', key: 'tipoCarga', type: 'text' },
    { header: 'Valores', key: 'valores', type: 'text' },
    { header: 'Eixos', key: 'eixos', type: 'text' },
    {
      header: 'Suspender',
      key: 'ativo',
      type: 'checkbox',
      action: (item: any) => this.suspenderPrecificacao(item)
    },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarPrecificacao(item)
        },
        {
          label: 'Excluir',
          img: 'assets/trashcan.png',
          action: (item: any) => this.excluirPrecificacao(item)
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private precoService: PrecoService,
    private authService: AuthService,
    private servicoService: ServicoService,
    private tipoCarretaService: TipoCarretaService,
    private tipoCargaService: CargaService,
    private reportService: ReportService,
    private appExportBase64: AppExportBase64,
    public swalAlert: SwalAlertService
  ) {}

  private _inicializarFormulario() {
    const form = this.fb.group({
      FK_SRVC: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      FK_TIPO_CRRT: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      FK_CRGA: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      NU_STTS_ALL: this.fb.control(0, {
        nonNullable: true,
        validators: [Validators.required]
      })
    });
    return form;
  }

  ngOnInit() {
    this.getPrecificacao();
    this.getServico();
    this.getTipoCarreta();
    this.getTipoCarga();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getPrecificacao();
    });
  }

  navegarPrecificacao() {
    this.router.navigate(['parametrizacao/precificacao']);
  }

  mudarPagina(pagina: number) {
    this.numeroPagina = pagina;
    this.getPrecificacao(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  getHours(date: Date) {
    if (date !== null) {
      return moment(date).format('HH:mm');
    }
    return '******';
  }

  getDate(date: Date) {
    if (date !== null) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '******';
  }

  getServico() {
    this.isLoading = true;
    this.servicoService.GetServico().subscribe(response => {
      this.servicoOptions = response.map((x: IGetServico) => {
        return {
          name: x.TX_TIPO_SRVC,
          value: x.PK_SRVC
        };
      });
    });
  }

  getTipoCarreta() {
    this.isLoading = true;
    this.tipoCarretaService.GetTipoCarreta().subscribe(response => {
      this.tipoCarretaOptions = response.map((x: IGetTipoCarreta) => {
        return {
          name: x.NM_TIPO_CRRT,
          value: x.PK_TIPO_CRRT
        };
      });
    });
  }

  getTipoCarga() {
    this.isLoading = true;
    this.tipoCargaService.GetCarga().subscribe(response => {
      this.tipoCargaOptions = response.map((x: IGetCarga) => {
        return {
          name: x.TX_CRGA,
          value: x.PK_CRGA
        };
      });
    });
  }

  atualizarCampo(campo: string, valor: any): void {
    if (
      this.form.controls[campo as keyof typeof this.form.controls].value !==
      valor
    ) {
      this.form.controls[campo as keyof typeof this.form.controls].setValue(
        valor as never
      );
    }
  }

  escolherOpcao(
    campo: keyof ListagemPrecificacaoComponent['form']['controls'],
    options: any[],
    value: any
  ): void {
    const selecionado = options.find(opcao => opcao?.value === Number(value));
    this.atualizarCampo(campo, selecionado?.value);
  }

  escolherServico(value: any): void {
    this.escolherOpcao('FK_SRVC', this.servicoOptions, value);
  }

  escolherTipoCarreta(value: any): void {
    this.escolherOpcao('FK_TIPO_CRRT', this.tipoCarretaOptions, value);
  }

  escolherTipoCarga(value: any): void {
    this.escolherOpcao('FK_CRGA', this.tipoCargaOptions, value);
  }

  escolherVisualizarSuspensos(value: any): void {
    this.escolherOpcao('NU_STTS_ALL', this.visualizarSuspensosOptions, value);
  }

  getPrecificacao(pageNumber?: number) {
    this.isLoading = true;

    const FK_SRVC = Number(this.form.controls.FK_SRVC.value);
    const FK_TIPO_CRRT = Number(this.form.controls.FK_TIPO_CRRT.value);
    const FK_CRGA = Number(this.form.controls.FK_CRGA.value);
    const NU_STTS_ALL = Number(this.form.controls.NU_STTS_ALL.value);

    this.authService.dadoLogin$.subscribe(({}) => {
      this.precoService
        .GetPreco({
          servico: FK_SRVC,
          tipoCarreta: FK_TIPO_CRRT,
          tipoCarga: FK_CRGA,
          pageNumber: pageNumber,
          pageSize: 20,
          status: NU_STTS_ALL
        })
        .subscribe({
          next: (response: IGetPrecoResponse) => {
            this.isLoading = false;
            this.maxPages = response.TOTAL_PAGES;
            this.tableData = response.ITEMS.map((item: IGetPreco) => {
              return {
                servico: item.TX_TIPO_SRVC ?? 'N/A',
                tipoCarreta: item.NM_TIPO_CRRT ?? 'N/A',
                tipoCarga: item.TX_CRGA ?? 'N/A',
                valores: formateMoney(String(item.VL_SRVC)),
                eixos: item.TX_TOTL_EIXO ?? 'N/A',
                ativo: item.NU_STTS_PRCO == 1 ? false : true,
                codigo: item.PK_PRCO,
                situacao: item.NU_STTS_PRCO
              };
            });
          },
          error: (_error: any) => {
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          }
        });
    });
  }

  editarPrecificacao(item: any) {
    const queryParams = {
      ...item,
      modoPrecificacao: 'Editar'
    };
    this.router.navigate(['cadastro/precificacao'], {
      queryParams: queryParams
    });
  }

  excluirPrecificacao(item: any) {
    this.swalAlert.showAlert(
      'Atenção!',
      'Deseja realizar a exclusão?',
      'warning',
      true,
      true,
      undefined,
      () => {
        const body: IPatchPreco = {
          NU_STTS_PRCO: 0
        };

        this.precoService.PatchPreco(item.codigo, body).subscribe(
          response => {
            this.getPrecificacao(this.numeroPagina + 1);
          },
          error => {}
        );
      }
    );
    this.swalAlert.showAlert(
      'Atenção!',
      'Deseja realizar a exclusão?',
      'warning',
      true,
      true,
      undefined,
      () => {
        const body: IPatchPreco = {
          NU_STTS_PRCO: 0
        };

        this.precoService.PatchPreco(item.codigo, body).subscribe(
          response => {
            this.getPrecificacao(this.numeroPagina + 1);
          },
          error => {}
        );
      }
    );
  }

  suspenderPrecificacao(item: any) {
    let statusPreco: number;

    statusPreco = item.situacao == 1 ? 2 : 1;

    const body: IPatchPreco = {
      NU_STTS_PRCO: statusPreco
    };

    this.precoService.PatchPreco(item.codigo, body).subscribe(
      response => {
        this.swalAlert.showAlert(
          'Sucesso',
          `${
            statusPreco == 1 ? 'Remoção da suspensão' : 'Suspensão'
          } realizada com sucesso.`,
          'success',
          true,
          false,
          undefined,
          () => {
            this.getPrecificacao(this.numeroPagina + 1);
          }
        );
      },
      error => {}
    );
  }

  exportarExcel() {
    this.isLoading = true;

    this.reportService.GetPreco().subscribe({
      next: (response: IGetReportBase64) => {
        this.appExportBase64.downloadExcel(
          response.ReportBase64,
          'tabela-preco'
        );
        this.isLoading = false;
      },
      error: _error => {
        this.isLoading = false;
      }
    });
  }

  visualizarPrecificacao(item: any) {
    const queryParams = {
      ...item,
      modoPrecificacao: 'Visualizar'
    };
    this.router.navigate(['cadastro/precificacao'], {
      queryParams: queryParams
    });
  }
}

